import { useEffect, useRef, useState } from "react"

/** Composer instructions belong to one notebook, not to an individual revision. */
export function useReportSteering(notebookId?: string) {
  const [steering, setValue] = useState("")
  const steeringRef = useRef<HTMLTextAreaElement>(null)
  const generated = useRef(false)
  useEffect(() => {
    setValue("")
    generated.current = false
  }, [notebookId])

  const setSteering = (value: string) => {
    generated.current = false
    setValue(value)
  }
  const selectSection = (title?: string) => {
    if (!steering.trim() || generated.current) {
      generated.current = true
      setValue(`In the ${title ? `“${title}”` : "selected"} section, `)
    }
    steeringRef.current?.focus()
    steeringRef.current?.scrollIntoView({ block: "center", behavior: "smooth" })
  }
  return { steering, setSteering, steeringRef, selectSection }
}
